<template>
  <div class="header-tab-component bg-white">
    <div class="left-wrap">
      <ul class="slide-wrap">
        <li
          v-for="(item, index) in slideData"
          :key="index"
          @click="routerJump(item)"
          class="slide-wrap-inner"
          :class="{ activeTab: tab === item.component }"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    slideData: {
      type: Array,
      required: true
    },
    tab: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // tabName: this.$route.query.name||this.slideData[0]&&this.slideData[0].component
    };
  },
  methods: {
    routerJump(item) {
      this.$emit("headerTabBack", item);
    }
  }
};
</script>

<style lang="scss" scoped>
.header-tab-component {
  height: 50px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  .left-wrap {
    height: 100%;
    display: flex;
    align-items: flex-end;
    .slide-wrap {
      line-height: 35px;
      .slide-wrap-inner {
        padding: 0 10px;
        display: inline-block;
        position: relative;
        margin: 0 10px;
        cursor: pointer;
        &::after {
          content: "";
          width: 0;
          height: 3px;
          position: absolute;
          bottom: -2px;
          left: 0;
          background: $globalBGColor;
          transition: all 0.1s;
        }
      }
      .activeTab {
        &::after {
          width: 100%;
        }
      }
    }
  }
}
</style>
